import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { Airport } from 'models/airport';
import { City } from 'models/city';

import Result from './styles';

export interface Props {
  data: Airport | City;
  isCity?: boolean;
  isRelatedAirport?: boolean;
  onClick: (data: Airport | City) => void;
}

const ResultItem = ({ data, isCity, onClick, isRelatedAirport }: Props) => {
  const { t } = useStoreTranslation();

  return (
    <Result onClick={() => onClick(data)}>
      {isRelatedAirport === true && (
        <Result.info.airport>
          <Result.Title>{`${data.related_city}, ${data.country}`}</Result.Title>
          <Result.SubTitle>
            {!isCity && <Result.iconairport />}
            {isCity ? t('airportsSearch.allAirports') : data.description}
          </Result.SubTitle>
        </Result.info.airport>
      )}

      {isRelatedAirport ||
        (isRelatedAirport === false && (
          <Result.info>
            <Result.Title>{`${data.related_city}, ${data.country}`}</Result.Title>
            <Result.SubTitle>
              {isCity && <Result.icon />}
              {!isCity && <Result.iconairport />}
              {isCity ? t('airportsSearch.allAirports') : data.description}
            </Result.SubTitle>
          </Result.info>
        ))}

      <Result.Code>{`${data.code}`}</Result.Code>
    </Result>
  );
};

export default ResultItem;
